import { User } from 'app/shared/models/user.model';

export class Group {
    id: string;
    name: string;
    complianceOfficer: User;
    manager: User;
    externalComplianceOfficer: User;
    memberUsers: Array<User>;
    groupId: string;
}



// WEBPACK FOOTER //
// ./src/app/admin/groups/group.model.ts